/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Error_MissingInputs */

const en_backend_session_error_missing = /** @type {(inputs: Backend_Session_Error_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active session was found on the backend. It may have been swept while booting. Please retry.`)
};

const fr_backend_session_error_missing = /** @type {(inputs: Backend_Session_Error_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune session active n'a été trouvée côté backend. Elle a peut-être été nettoyée pendant le boot. Réessayez.`)
};

const ms_sg2_backend_session_error_missing = /** @type {(inputs: Backend_Session_Error_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada sesi aktif ditemui di backend. Mungkin telah dibersihkan semasa permulaan. Sila cuba semula.`)
};

/**
* | output |
* | --- |
* | "No active session was found on the backend. It may have been swept while booting. Please retry." |
*
* @param {Backend_Session_Error_MissingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_missing = /** @type {((inputs?: Backend_Session_Error_MissingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_MissingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_missing(inputs)
	if (locale === "fr") return fr_backend_session_error_missing(inputs)
	return ms_sg2_backend_session_error_missing(inputs)
});